import type { API, CartLineInput, CartUpsell, Checkout, Country, StagedUpsell, Variant } from '~/types'
import { GQLError, makeActionCreator, makeMetaActionCreator } from '~/utils'

export interface AddToCartLine extends Partial<Variant>, Partial<CartLineInput> {
	id: VariantID
	quantity: number
}

/**
 * Actions starting with CART_ are saved to localStorage by default,
 * remember to exclude them in {@link saveState}
 */
export default {
	loadCart: makeActionCreator()('CART_FETCH'),
	cartFetched: makeActionCreator<Checkout>()('CART_FETCHED'),
	cartLoaded: makeActionCreator<Checkout>()('CART_LOAD_SUCCESS'),
	cartUpsellsLoaded: makeActionCreator<CartUpsell[]>()('CART_UPSELLS_LOAD_SUCCESS'),

	addToCart: makeActionCreator<AddToCartLine[]>()('CART_ADD', { optimistic: true }),
	updateQuantity: makeActionCreator<number, LineItemID>()('CART_QUANTITY_UPDATE', { optimistic: true }),
	removeFromCart: makeMetaActionCreator<LineItemID>()('CART_REMOVE', { optimistic: true }),

	updateCartSucess: makeActionCreator<Checkout>()('CART_UPDATE_SUCCESS'),
	updateCartError: makeActionCreator<Checkout, GQLError[]>()('CART_UPDATE_ERROR'),

	updateCartCountry: makeActionCreator<Country, HTMLFormElement>()('CART_COUNTRY_UPDATE'),
	updateCartCountrySuccesss: makeActionCreator<Checkout, Country>()('CART_COUNTRY_UPDATE_SUCCESS'),

	updateCartBuyerIdentity: makeActionCreator<Country>()('CART_BUYER_IDENTITY_UPDATE'),

	openCart: makeActionCreator<boolean>()('CART_OPEN'),

	addUpsell: makeActionCreator<StagedUpsell>()('UPSELL_ADD'),
	removeUpsell: makeMetaActionCreator<LineItemID>()('UPSELL_REMOVE'),
	updateUpsell: makeActionCreator<Partial<StagedUpsell>, LineItemID>()('UPSELL_UPDATE'),

	loadDeliveryProfiles: makeActionCreator()('SHIPPING_SETTINGS_LOAD'),
	deliveryProfilesLoaded: makeActionCreator<API.ShippingSetting[]>()('SHIPPING_SETTINGS_LOAD_SUCCESS'),

	loadMarkets: makeActionCreator()('MARKETS_LOAD'),
	marketsLoaded: makeActionCreator<API.MarketConfig[]>()('MARKETS_LOAD_SUCCESS')
}
